import React, { Component } from 'react'
import { connect } from 'react-redux'
import { RadioInput, ConfirmFields, Select, TextInput } from './Form'
import { DumbField } from '../Field'
import { getRecordsByUser } from '../WizardActions'
import { getValidityClass } from '../Field'
import ReactMarkdown from 'components/Markdown/Markdown'
import { MASK } from '../validate'
import { noop } from 'utilities'
import { GET_BY_ID } from '../../../requests'
import * as WizardClasses from '../WizardClasses'
import { resolveFieldConditions } from '@tecuity/wizard-utilities'
import FileUpload from './FileUpload'

const ADDITIONAL = {
  trade: {
    label: 'Trade',
    optionsSrc: 'tradeNames',
  },
  fictitious: {
    label: 'Fictitious',
    optionsSrc: 'fictitiousNames',
  },
}

const RESERVED = {
  reserved: {
    label: 'Reserved',
    optionsSrc: 'reservedNames',
  },
  foreignRegistered: {
    label: 'Foreign Registered',
    optionsSrc: 'foreignRegisteredNames',
  },
}
const emptyOption = { value: '', label: '[Select an Option]' }

class EntityNameSearch extends Component {
  constructor(props) {
    super()
    this.state = {
      foreignRegisteredNames: [],
      reservedNames: [],
      tradeNames: [],
      fictitiousNames: [],
      uploadValue: [],
    }
  }
  componentDidMount = () => {
    const bypassNameNotTakenCheck = this.props.businessRules.find(
      (rule) => rule.fn == 'validateEntityNameFields'
    )
      ? this.props.businessRules.find((rule) => rule.fn == 'validateEntityNameFields').props
          .disableNameNotTakenCheck
      : false
    bypassNameNotTakenCheck &&
      !this.props.value.bypassNameNotTakenCheck &&
      this.props.onChange({ ...this.props.value, bypassNameNotTakenCheck: bypassNameNotTakenCheck })
    if (this.props.isFirst) {
      try {
        this.focusTarget.focus()
      } catch (e) {
        console.warn('Attempted to focus unfocusable element', e)
      }
    }

    if (this.props.value) {
      if (Array.isArray(this.props.value) && this.props.value.length > 0) {
        this.getMultiById(this.props.value)
      } else {
        this.props.value.SOURCE_ID && this.getById(this.props.value.SOURCE_ID)
      }
    }

    this.props.getRecordsByUser('ForeignRegisteredName', (foreignRegisteredNames) => {
      this.setState({
        foreignRegisteredNames: (foreignRegisteredNames && Array.isArray(foreignRegisteredNames)
          ? foreignRegisteredNames
          : []
        ).map((name) => ({
          value: name.SourceId,
          label: `${name.Name}`,
          num: name.SourceNum,
          name: name.Name,
        })),
      })
    })
    this.props.getRecordsByUser('ReservedName', (reservedNames) => {
      this.setState({
        reservedNames: (reservedNames && Array.isArray(reservedNames) ? reservedNames : []).map(
          (name) => ({
            value: name.SourceId,
            label: `${name.Name}`,
            num: name.SourceNum,
            name: name.Name,
          })
        ),
      })
    })
    this.props.getRecordsByUser('TradeName', (tradeNames) => {
      this.setState({
        tradeNames: (tradeNames && Array.isArray(tradeNames) ? tradeNames : []).map((name) => ({
          value: name.SourceId,
          label: `${name.Name}`,
          num: name.SourceNum,
          name: name.Name,
        })),
      })
    })
    this.props.getRecordsByUser('PartnershipFictitiousName', (ficNames) => {
      this.setState({
        fictitiousNames: (ficNames && Array.isArray(ficNames) ? ficNames : []).map((name) => ({
          value: name.SourceId,
          label: `${name.Name}`,
          num: name.SourceNum,
          name: name.Name,
        })),
      })
    })
  }

  getById = (sourceId, callback) =>
    new Promise((resolve, reject) => {
      if (sourceId) {
        const SEARCH_TYPE = this.props.searchType || 'QualifiedOrganizations'
        const query = `?${this.getSearchQuery()}`
        GET_BY_ID(SEARCH_TYPE, sourceId + query, (result) => {
          this.setState({ loading: false })
          this.props.onChange(result, { target: { name: this.props.name } })
          resolve(result)
        })
      } else {
        reject()
      }
    })

  getMultiById = (results) => {
    this.setState({ loadingMultiResults: true })
    const promises = results.map(
      (result) =>
        new Promise((resolve, reject) => {
          if (result.SOURCE_ID) {
            const SEARCH_TYPE = this.props.searchType || 'QualifiedOrganizations'
            GET_BY_ID(SEARCH_TYPE, result.SOURCE_ID, resolve)
          } else {
            reject()
          }
        })
    )

    Promise.all(promises).then((values) => {
      this.setState({ loadingMultiResults: false })
      this.props.onChange(values, {})
    })
  }

  getSearchQuery = () => {
    const parameterFields = this.getFieldParameters()
    const params =
      this.props.additionalParameters || Object.keys(parameterFields).length
        ? { ...parameterFields, ...this.props.additionalParameters }
        : {}
    const paramsString = Object.entries(params).reduce((str, [key, value], index) => {
      if (index !== 0) {
        str += '&'
      }
      str += `${key}=${encodeURIComponent(
        typeof value === 'object' ? JSON.stringify(value) : value
      )}`
      return str
    }, '')
    return paramsString
  }
  getFieldParameters = () => {
    return (this.props.parameterFields || [])
      .map((fieldId) => this.props.fields[fieldId])
      .filter((x) => x)
      .filter((field) =>
        resolveFieldConditions(field.conditions, this.props.fields, field.conditionsOperator)
      )
      .map(
        (field) =>
          new WizardClasses[field.fieldClass](field).getKeyValuePairs(field, this.props.fields)[0]
      )
      .reduce(
        (obj, kv) => ({
          ...obj,
          [kv.name]: kv.value,
        }),
        {}
      )
  }

  setAdditionalName = (value, e) => {
    const foundNameTrade = this.state.tradeNames.find((name) => name.value == value)
    const additionalName = foundNameTrade ? foundNameTrade.name : ''
    this.props.onChange({ ...this.props.value, [e.target.name]: value, additionalName })
  }
  setAdditionalName = (value, e) => {
    const foundNameTrade = this.state.tradeNames.find((name) => name.value == value)
    const additionalName = foundNameTrade ? foundNameTrade.name : ''
    this.props.onChange({ ...this.props.value, [e.target.name]: value, additionalName })
  }
  setFieldValueByName = (value, e) => {
    this.props.onChange({ ...this.props.value, [e.target.name]: value })
  }
  setReservedName = (reservedId, e) => {
    const foundName = this.state[this.props.value.reservedMode + 'Names'].find(
      (name) => name.value == reservedId
    )
    const reservedName = foundName ? foundName.name : ''
    const reservedNum = foundName ? foundName.num : ''
    this.props.onChange({
      ...this.props.value,
      [e.target.name]: reservedId,
      reservedName,
      reservedNum,
      ...(this.props.allowReservedNameEditing
        ? {
            val1: reservedName,
            val2: reservedName,
          }
        : {}),
    })
  }
  setReservedNameYN = (value, e) => {
    if (value === 'N') {
      this.props.onChange({
        ...this.props.value,
        [e.target.name]: value,
        reservedNameId: '',
        reservedName: '',
        reservedNum: '',
        ...(this.props.allowReservedNameEditing
          ? {
              val1: '',
              val2: '',
            }
          : {}),
      })
    } else {
      this.setFieldValueByName(value, e)
    }
  }
  setAdditionalName = (value, e) => {
    const foundNameTrade = this.state[this.props.value.additionalMode + 'Names'].find(
      (name) => name.value == value
    )
    const additionalName = foundNameTrade ? foundNameTrade.name : ''
    this.props.onChange({ ...this.props.value, [e.target.name]: value, additionalName })
  }
  setConfirmFieldsValue = (value, e) => {
    this.props.onChange({ ...this.props.value, ...value }, e)
  }
  // bubbleBlurEvent = (value, e) => {
  //   this.props.onBlur(this.props.value, e)
  // }
  getValidityClass = (ruleId) => {
    const errors = this.getErrors()
    return getValidityClass(errors[ruleId] ? errors[ruleId].isValid : null)
  }
  getErrorMessage = (ruleId) => {
    const errors = this.getErrors()
    return errors[ruleId] ? errors[ruleId].errorMessage : []
  }
  applyMaskByMaskId = (maskId, value, e) => {
    switch (maskId) {
      case 'onlyNumbers':
        this.setFieldValueByName(MASK.onlyNumbers(value), e)
        break
    }
  }
  onBlur = (value, e, extraPayload, overrideSetValue, options) => {
    extraPayload = { ...this.getFieldParameters(), ...extraPayload }
    this.props.onBlur(this.props.value, e, extraPayload, overrideSetValue, options)
  }
  getErrors = () =>
    this.props.errorMessage ? (this.props.errorMessage[0] ? this.props.errorMessage[0] : {}) : {}
  reduceErrors = (errors) => {
    return errors.reduce((isValid, err) => {
      if (isValid === false) return isValid
      if (err) return err.isValid
      return isValid
    }, null)
  }
  collectUpload = (value, e) => {
    this.props.onChange({ ...this.props.value, uploadField: value })
  }
  render() {
    const {
      value,
      errorMessage,
      hideReserved,
      reservedLabel,
      allowReservedNameEditing,
      hideAdditionalName,
      additionalLabel,
      additionalDescription,
      nameLabel,
      nameDescription,
      nameConfirmLabel,
      nameMatch,
      hideConsent,
      hideNumConsent,
      consentLabel,
      required,
      disabled,
      tradeOptionLabel1,
      tradeOptionLabel2,
      consentOptionLabel1,
      consentOptionLabel2,
      consentDescription,
      consentInstructions,
      nameWidth,
      infoMessage,
      accept,
    } = this.props
    const additionalNameShown = !hideAdditionalName
    const errors = errorMessage ? (errorMessage[0] ? errorMessage[0] : {}) : {}
    return (
      <div>
        {!hideReserved && (
          <DumbField
            label={reservedLabel}
            ownsLabel
            errorMessage={this.getErrorMessage('mustSelectReservedOption')}
            required={required}
          >
            <RadioInput
              label={reservedLabel}
              ownsLabel
              validityClass={this.getValidityClass('mustSelectReservedOption')}
              options={[
                { value: 'Y', label: 'Yes' },
                { value: 'N', label: 'No' },
              ]}
              value={value.reservedYN}
              name="reservedYN"
              fieldId="reservedYN"
              onChange={this.setReservedNameYN}
              ref={(focusTarget) => {
                this.focusTarget = focusTarget
              }}
              disabled={disabled}
            />
          </DumbField>
        )}
        {value.reservedYN === 'Y' && !hideReserved && (
          <div>
            {/* <DumbField label='Search for a reserved name'>
              <SearchControl value={{}} metadata={{SEARCH_TYPE: 33}}/>
            </DumbField> */}
            <DumbField
              label={`Select a ${RESERVED[value.reservedMode].label.toLowerCase()} name`}
              errorMessage={[
                ...this.getErrorMessage('mustSelectReservedName'),
                ...this.getErrorMessage('entityIsValidName'),
              ]}
              infoMessage={infoMessage !== '' && infoMessage ? [infoMessage] : ''}
              required={required}
            >
              <Select
                isValid={this.reduceErrors([errors.entityIsValidName])}
                validityClass={this.getValidityClass('mustSelectReservedName')}
                width="40%"
                onBlur={this.onBlur}
                options={[emptyOption, ...this.state[RESERVED[value.reservedMode].optionsSrc]]}
                onChange={this.setReservedName}
                value={value.reservedNameId}
                name="reservedNameId"
                disabled={disabled}
              />
            </DumbField>
          </div>
        )}
        {(value.reservedYN === 'N' ||
          hideReserved ||
          (allowReservedNameEditing && value.reservedYN === 'Y')) && (
          <DumbField
            hideLabel
            errorMessage={[
              ...this.getErrorMessage('entityNameRequired'),
              ...this.getErrorMessage('entityValuesMatch'),
              ...this.getErrorMessage('entityNameNotTaken'),
              ...this.getErrorMessage('entityIsValidName'),
            ]}
            infoMessage={infoMessage !== '' && infoMessage ? [infoMessage] : ''}
          >
            <ConfirmFields
              isValid={this.reduceErrors([
                errors.entityNameRequired,
                errors.entityValuesMatch,
                errors.entityNameNotTaken,
                errors.entityIsValidName,
              ])}
              label={nameLabel}
              confirmFieldLabel={nameConfirmLabel}
              description={nameDescription}
              value={value}
              match={nameMatch}
              width={nameWidth}
              onChange={this.setConfirmFieldsValue}
              onBlur={this.onBlur}
              required={required}
              disabled={disabled}
            />
          </DumbField>
        )}
        {(value.reservedYN === 'N' || hideReserved) && additionalNameShown && (
          <DumbField
            label={additionalLabel}
            ownsLabel
            errorMessage={this.getErrorMessage('mustSelectAdditionalOption')}
            required={required}
          >
            <RadioInput
              label={additionalLabel}
              ownsLabel
              validityClass={this.getValidityClass('mustSelectAdditionalOption')}
              options={[
                { value: 'N', label: tradeOptionLabel1 },
                { value: 'Y', label: tradeOptionLabel2 },
              ]}
              description={additionalDescription}
              value={value.additionalYN}
              name="additionalYN"
              onChange={this.setFieldValueByName}
              disabled={disabled}
            />
          </DumbField>
        )}
        <div className="dependent-field">
          {(value.reservedYN === 'N' || hideReserved) &&
            value.additionalYN === 'Y' &&
            additionalNameShown && (
              <DumbField
                label={`Select a ${ADDITIONAL[value.additionalMode].label.toLowerCase()} name`}
                errorMessage={this.getErrorMessage('mustSelectAdditionalName')}
                required={required}
              >
                <Select
                  validityClass={this.getValidityClass('mustSelectAdditionalName')}
                  width="40%"
                  onBlur={noop}
                  options={[
                    emptyOption,
                    ...this.state[ADDITIONAL[value.additionalMode].optionsSrc],
                  ]}
                  onChange={this.setAdditionalName}
                  name="additionalNameId"
                  value={value.additionalNameId}
                />
              </DumbField>
            )}
        </div>
        {(value.reservedYN === 'N' || hideReserved) &&
          (value.additionalYN === 'N' || !additionalNameShown) &&
          !hideConsent && (
            <DumbField
              className={additionalNameShown ? 'consent' : ''}
              label={consentLabel}
              ownsLabel
              errorMessage={this.getErrorMessage('mustSelectConsentOption')}
              required={required}
            >
              <RadioInput
                label={consentLabel}
                ownsLabel
                validityClass={this.getValidityClass('mustSelectConsentOption')}
                description={consentDescription}
                options={[
                  { value: 'N', label: consentOptionLabel1 },
                  { value: 'Y', label: consentOptionLabel2 },
                ]}
                value={value.consentYN}
                name="consentYN"
                onChange={this.setFieldValueByName}
                disabled={disabled}
              />
            </DumbField>
          )}
        <div className="dependent-field">
          {(value.reservedYN === 'N' || hideReserved) &&
            (value.additionalYN === 'N' || !additionalNameShown) &&
            value.consentYN === 'Y' &&
            !hideConsent && (
              <div>
                <ReactMarkdown source={consentInstructions} className="markdown" />
                {!hideNumConsent && (
                  <DumbField
                    label="Number of consents"
                    className=""
                    description={`Enter the number of consents required.

If multiple Consents are needed, each Consent is to be counted as one Consent.  However, if the same holder is authorized to sign, these may be combined and counted as one Consent.`}
                    errorMessage={this.getErrorMessage('numConsentsRequired')}
                    required={required}
                  >
                    <TextInput
                      validityClass={this.getValidityClass('numConsentsRequired')}
                      value={value.numConsents}
                      name="numConsents"
                      onChange={(value, e) => {
                        this.applyMaskByMaskId('onlyNumbers', value, e)
                      }}
                      onBlur={noop}
                      placeholder="(Enter number of consents required)"
                      width="40%"
                      disabled={disabled}
                    />
                  </DumbField>
                )}
                <DumbField
                  label="Upload consent(s)"
                  className=""
                  description={`If multiple Consents are needed, please upload one file for each consent.`}
                  errorMessage={this.getErrorMessage('consentUploadRequired')}
                  required
                >
                  <FileUpload
                    validityClass={this.getValidityClass('consentUploadRequired')}
                    disabled={disabled}
                    parent={{ type: 'EntityNameSearch', id: this.props.fieldId }}
                    errorMessage={this.getErrorMessage('consentUploadRequired')}
                    fieldId={`${this.props.fieldId}-FileUpload`}
                    name={`${this.props.fieldId}-FileUpload`}
                    onChange={this.collectUpload}
                    accept={accept}
                    multiple
                    category={this.props.category}
                    value={value.uploadField}
                    required
                    onBlur={this.onBlur}
                    ariaLabelledby="Upload consent(s)"
                  />
                </DumbField>
              </div>
            )}
        </div>
      </div>
    )
  }
}
export default connect(
  (state) => ({
    fields: state.wizard.wizard.fields,
    category: state.wizard.wizard.category || state.designer.wizard.category,
  }),
  { getRecordsByUser }
)(EntityNameSearch)
